import { useTheme } from '@emotion/react'
import { Chip } from '@mui/material'
import { formatDate } from 'date-fns'
import { CompanyStatus } from 'recruiter/types/CompanyStatus'

const CompanyStatusPill = ({ status, nonPoachDate }) => {
    const theme = useTheme()
    const backgroundColor = (() => {
        switch (status) {
            case CompanyStatus['Client']:
                return theme.palette.status.blue
            case CompanyStatus['Tread Carefully']:
                return theme.palette.status.pink
            case CompanyStatus['Non-Poach']:
                return theme.palette.status.orange
            case CompanyStatus['Susceptible']:
                return theme.palette.status.red
            case CompanyStatus['No Status']:
            default:
                return theme.palette.status.grey
        }
    })()

    return (
        <Chip
            title="Status"
            size="small"
            label={
                nonPoachDate && status === CompanyStatus['Non-Poach']
                    ? `${status} (${formatDate(nonPoachDate, 'MM/dd/yy')})`
                    : status
            }
            sx={{ backgroundColor, color: theme.palette.greyscale.white }}
        />
    )
}

export default CompanyStatusPill
